module.exports = __webpack_public_path__ + "img/no-issues-found-static-140px.414b0e3.webp";